<template>
  <div id="menu">
    <div v-on:click="selectauthor=!selectauthor"><u>{{curauthor}}</u></div>
  </div>
  <div v-show="selectauthor" id="popup">
    <listview v-show="selectauthor" id="subjectselect" v-for="author in allauthors">
      <div v-on:click="authorclick(author)">
        {{ author }}
      </div>
    </listview>
  </div>
  <div v-on:click="hidepop" id="booklist" >
    <table border="1" style="width: 100%;">
      <tr v-for="book in books">
        <td width="85%">{{book.bookname}}</td>
        <td width="15%"><a a v-bind:href="book.booklink">{{book.open}}</a></td>
      </tr>
    </table>
  </div>
  <div v-on:click="hidepop" id="page" >
    <div class="hlink" v-on:click="prevpage" style="width: 30%;"><u>前一页</u></div>
    <div style="width: 40%;">第{{ pageno }}页，共{{ total }}页</div>
    <div class="hlink" v-on:click="nextpage" style="width: 30%;"><u>后一页</u></div>
  </div>
  <div v-on:click="hidepop" id="icp" >
	  <a href="https://beian.miit.gov.cn/#/Integrated/index">沪ICP备2025140105号</a>
  </div>
</template>

<style>
#booklist {
  text-align: left;
  position: absolute;
  margin-left: 5px;
  margin-right: 20px;
  width: calc(100% - 25px);
  height: calc(100% - 150px);
  top: 100px;
  font-size: 20px;
  display: block;
  overflow: auto;
}

#page {
  position: absolute;
  top: calc(100% - 60px);
  width: 100%;
  height: 30px;
  display: flex;
  font-size: 20px;
}

#icp {
  position: absolute;
  top: calc(100% - 30px);
  width: 100%;
  height: 20px;
  display: flex;
  font-size: 14px;
}
</style>

<script lang="ts">
import { Vue } from 'vue-class-component';
import axios from "axios"

const instance = axios.create({
  baseURL: 'http://www.baseongrace.com:8021/api/',
  timeout: 50000,
});

export default class Book extends Vue {
  public pageno:number = 0;
  public total:number = 0;
  public pagecount:number = 50;
  public books:Array<any> = [];
  public allauthors:Array<any> = [];
  public curauthor:string = "";
  public selectauthor:boolean = false;

  authorclick(author:string) {
    this.hidepop();
    this.curauthor = author;
    const params = new URLSearchParams();
    params.append('author', this.curauthor);
    params.append('hide', "0");
    instance.get("TruthView/GetBookCount", {params}).then((response) => {
      this.total = Math.floor((response.data.data + this.pagecount - 1) / this.pagecount);
      this.pageno = 1;
      this.getpagebook();
    })
    .catch(function (error) {
    });
  }

  hidepop() {
    this.selectauthor = false;
  }

  getpagebook() {
    const params = new URLSearchParams();
    params.append('author', this.curauthor);
    params.append('pageno', this.pageno.toString());
    params.append('pagecount', this.pagecount.toString());
    params.append('hide', "0");
    instance.get("TruthView/GetPageBooks", {params}).then((response) => {
      this.books = response.data.data;
      this.books.forEach(element => {
        element.link = "books/" + element.author + "/" + element.filename;
        if (element.hasBook == true) {
          element.booklink = "http://www.baseongrace.com:8021/api/TruthView/ShowBookContent?bookno=" + element.bookno + "&contentno=0";
          element.open = "阅读";
        }
      });
    })
    .catch(function (error) {
    });
  }
  
  prevpage() {
    if (this.pageno > 1) {
      this.pageno--
      this.getpagebook();
    }
  }

  nextpage() {
    if(this.pageno < this.total) {
      this.pageno++;
      this.getpagebook();
    }
  }

  mounted() {
    const params = new URLSearchParams();
    params.append('hide', "0");
    instance.get("TruthView/GetBookAuthors", {params}).then((response) => {
      this.allauthors.push("全部");
      var authors:Array<String> = response.data.data;
      authors.forEach(element => {
        this.allauthors.push(element);
      });
      this.authorclick("全部");
    })
    .catch(function (error) {
    });
  }
}
</script>
